import {EmbeddedCheckout, EmbeddedCheckoutProvider} from "@stripe/react-stripe-js";
import React from "react";

export default function CheckoutForm({stripe, pagesClientSecret }) {

    return (
        <div id="checkout">
            {stripe && pagesClientSecret && (
                <EmbeddedCheckoutProvider stripe={stripe} options={{ clientSecret: pagesClientSecret }}>
                    <EmbeddedCheckout />
                </EmbeddedCheckoutProvider>
            )}
        </div>
    );
}
